import Head from "next/head";
import { SeoModel } from "../../../models/seo";

const socialTags = ({
  url,
  title,
  description,
  image,
  videoLink,
  type = "other"
}: SeoModel) => {
  const metaTags = [
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:url", content: url },
    { name: "twitter:image", content: image },
    { name: "twitter:image:src", content: image },
    { name: "twitter:image:alt", content: title },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:site", content: "@digitoon.tv" },
    { name: "twitter:creator", content: "@digitoon.tv" },
    { name: "og:title", content: title },
    { name: "og:url", content: url },
    { name: "og:image", content: image },
    { name: "og:image:alt", content: title },
    { name: "og:image:secure_url", content: image },
    { name: "og:image:type", content: "image/jpeg" },
    { name: "og:description", content: description },
    {
      name: "og:site_name",
      content: type === "article" ? "دیجیتون مگ " : "دیجیتون"
    },
    { name: "og:locale", content: "fa_IR" }
  ];

  return metaTags;
};

function Seo({
  url = "https://www.digitoon.tv/",
  title = "دیجیتون",
  name,
  description = "دیجیتون",
  image = "",
  keywords,
  videoLink = "",
  videoDuration = 0,
  type,
  date_published,
  canonicalUrl
}: SeoModel) {
  return (
    <Head>
      <title>{title}</title>
      <meta itemProp="name" content={name ?? title} />
      <meta itemProp="title" content={title} />
      <meta name="title" content={title} />
      <meta itemProp="image" content={image} />
      <meta name="description" content={description} />
      <meta itemProp="description" content={description} />
      <meta http-equiv="content-language" content="fa" />
      <meta name="language" content="fa" />
      <meta
        name="google-site-verification"
        content="qqB1AnVcokBL8zB1XLlSWvVIKNIeUa0jH84Cbp13qe0"
      />
      {videoLink && (
        <>
          <meta name="og:video" content={videoLink} />
          <meta name="og:video:secure_url" content={videoLink} />
        </>
      )}
      {type === "video.movie" && (
        <>
          <meta name="og:video:type" content="video/mp4" />
          <meta property="video:duration" content={videoDuration.toString()} />
          <meta property="og:type" content={type} />
        </>
      )}
      {type === "article" && (
        <>
          {/* <meta property="article:published_time" content={date_published} />
            <meta property="article:modified_time" content={date_published} /> */}
          <meta name="author" content=" دیجیتون " />
          <meta name="twitter:label1" content="دیجیتون" />
          <meta name="twitter:data1" content="دیجیتون" />
          <meta property="og:image:width" content="720" />
          <meta property="og:image:height" content="450" />
          <meta property="og:type" content={type} />
          <meta name="next-head-count" content="41" />
        </>
      )}
      {keywords && <meta name="keywords" content={keywords} />}
      {!!canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {socialTags({ url, title, image, description, videoLink, type }).map(
        ({ name, content }) => {
          return <meta key={name} property={name} content={content} />;
        }
      )}
    </Head>
  );
}

export default Seo;

export const homeSeo = {
  title: "دیجیتون: تماشا و دانلود کارتون و انیمیشن با اینترنت رایگان",
  description:
    "انیمیشن و کارتون با زیرنویس و دوبله فارسی  با اینترنت رایگان | دیجیتون دنیایی از کارتون های جدید ایرانی و خارجی",
  image: "https://www.digitoon.tv/assets/images/header/mini-logo.png",
  url: "https://www.digitoon.tv",
  canonicalUrl: "https://www.digitoon.tv",
  keywords:
    "کارتون,انیمیشن,کارتون دوبله فارسی,انیمیشن دوبله فارسی,دانلود کارتون,دانلود انیمیشن,کارتون باب اسفنجی,کارتون باب اسفنجی جدید,باب اسفنجی دوبله فارسی,سگ های نگهبان ,سگهای نگهبان,کارتون سگ های نگهبان,ماجراجویی در پاریس ,دختر کفشدوزکی,کارتون دختر کفشدوزکی,دختر کفش دوزکی,فروزن,فروزن 2,انیمیشن دختر کفشدوزکی,السا و آنا,انیمیشن فروزن,کارتون بچه رئیس,بچه رییس,بچه رئیس,بجه رییس دوبله فارسی,انیمیشن قرمز شدن ,کارتون قرمز شدن,بن 10,بن تن,کارتون بن 10,کارتون بن تن,پپاپیگ,بتمن ,بتویلز,بت ویلز,گروه شب نقاب,لاک پشت های نینجا,پاندای کونگ فو کار ,پاندای کنگفو کار,مرد عنکبوتی ,اسپایدر من,سونیک ,سونیک 2,nd[dj,k,یهلهفخخد,سینمای آنلاین,پخش فیلم,پخش آنلاین فیلم,آنلاین,فیلم,دانلود ,movie,film,season,video,download movie,download,download film,online,تماشای آنلاین,فیلم جدید,دیجیتون,دیجی تون,دیجیتن,digiton,کارتون ایرانی,کارتون دوبله,کارتون جدید,برنامه کودک,دیجیتون,کارتون رایگان,kartoon,animation"
};
export const homeBlogSeo = {
  title: "دیجیتون مگ | وبلاگ دیجیتون",
  name: "همه چیز در مورد انیمیشن و دنیای کودک",
  url: "https://www.digitoon.tv/blog",
  image:
    "https://www.digitoon.tv/_next/image?url=%2Fimages%2Fblog%2Flogo.png&w=384&q=75",
  description:
    "دیجیتون مگ دنیایی از اطلاعات در مورد انیمیشن ها و فیلم های حوزه کودک و نوجوان را در اختیار شما می گذارد.",
  keywords:
    "دیجیتون مگ,وبلاگ دیجیتون,کارتون,انیمیشن,معرفی کارتون,معرفی انیمیشن,بهترین انیمیشن ها,انیمیشن سینمایی,انیمیشن خردسال,انیمیشن سریالی,دوبله زنده,کودک,محتوای کودک,بهترین کارتون ها,بهترین انیمیشن ها,جدید ترین کارتون ها,جدید ترین انیمیشن ها"
};
